import { IEntity } from "./IEntity";

interface IDream extends IEntity {
    name: string;
    difficulty: number;
    attributes: string[];
    emotion: string;
    linkid: number | null;
    notes: string;
    isresonating: boolean;
}

export default IDream;

export const resourceNameDream = `dream`;
